import { render } from "./PreviewStatus.vue?vue&type=template&id=5188b586&scoped=true"
import script from "./PreviewStatus.vue?vue&type=script&lang=js"
export * from "./PreviewStatus.vue?vue&type=script&lang=js"

import "./PreviewStatus.vue?vue&type=style&index=0&id=5188b586&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5188b586"]])

export default __exports__